export default "__VITE_ASSET__9qgyObCr__"